/** @format */

import React, { useState } from 'react';
import { Grid, IconButton, Button, FormControlLabel, Checkbox } from '@mui/material';
import { InputV, SimpleDialog, Icons } from 'components';
import { useFieldArray, Controller, useFormContext } from 'react-hook-form';
import { CheckBoxIcon, CheckBoxIconFill } from 'components/CheckBox/CheckBoxIcon';

const HeaderParameters = (props) => {
  const methods = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control: methods.control,
    name: 'scHeaderParams',
  });

  const [openDialog, setOpenDialog] = useState(false);
  const [indexSelected, setIndexSelected] = useState(-1);

  const addParamHeader = () => {
    append({
      scParameterName: '',
      scParameterDesc: '',
      scHiddenParameter: true,
    });
  };

  const removeRow = (index) => {
    setIndexSelected(index);
    setOpenDialog(true);
  };

  const ActionsBtn = () => {
    return (
      <>
        <Button onClick={confirmRemove} variant="contained" color="primary">
          تایید
        </Button>
        <Button onClick={closeDialog} variant="contained">
          انصراف
        </Button>
      </>
    );
  };

  const closeDialog = () => {
    setOpenDialog(false);
  };

  const confirmRemove = () => {
    setOpenDialog(false);
    remove(indexSelected);
    setIndexSelected(-1);
  };

  return (
    <>
      <SimpleDialog
        title="حذف پارامتر Header"
        content="آیا از حذف پارامتر اطمینان دارید؟"
        open={true}
        actions={<ActionsBtn />}
      />
      <Grid container direction="row" alignItems="center" spacing={4}>
        {fields.map((field, index) => {
          return (
            <React.Fragment key={field.id}>
              <Grid item xs={3}>
                <InputV
                  fullWidth
                  errors={methods.formState.errors}
                  name={`scHeaderParams[${index}].scParameterName`}
                  register={methods.register}
                  rules={['required']}
                  control={methods.control}
                  defaultValue={field.scParameterName}
                />
              </Grid>

              <Grid item xs={1}>
                <Controller
                  name={`scHeaderParams[${index}].scHiddenParameter`}
                  control={methods.control}
                  render={({ field: props }) => (
                    <FormControlLabel
                      value
                      control={
                        <Checkbox
                          onChange={(e) => props.onChange(e.target.checked)}
                          checked={props.value}
                          icon={<CheckBoxIcon />}
                          checkedIcon={<CheckBoxIconFill />}
                        />
                      }
                      label="Hidden"
                    />
                  )}
                  defaultValue={field.scHiddenParameter}
                />
              </Grid>

              <Grid item xs={3}>
                <InputV
                  fullWidth
                  errors={methods.formState.errors}
                  name={`scHeaderParams[${index}].scParameterDefaultValue`}
                  register={methods.register}
                  rules={['required']}
                  control={methods.control}
                  defaultValue={field.scParameterDefaultValue}
                />
              </Grid>

              <Grid item xs={4}>
                <InputV
                  fullWidth
                  errors={methods.formState.errors}
                  name={`scHeaderParams[${index}].scParameterDesc`}
                  register={methods.register}
                  rules={['required']}
                  control={methods.control}
                  defaultValue={field.scParameterDesc}
                />
              </Grid>

              <Grid item xs={1}>
                <IconButton
                  variant="contained"
                  color="secondary"
                  aria-label="delete"
                  onClick={() => removeRow(index)}
                  size="large">
                  <Icons icon="CloseCircle" color="#343434" size="18" />
                </IconButton>
              </Grid>
            </React.Fragment>
          );
        })}
        <Grid item xs={12}>
          <Button color="primary" variant="contained" type="button" onClick={addParamHeader}>
            افزودن
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default HeaderParameters;
